<template>
  <div class="comp-ly-field-mapping" ref="lyFieldMappingRef">
    <jw-form :model="data.form" label-align="left" class="sub-form-drawer" ref="formRef" @submit="handleSubmit" :key="randomKey">
      <jw-row class="mapping-grid" :gutter="8">
        <template v-for="(item, index) in mappingList" :key="index">
          <jw-col span="9">
            <jw-form-item :field="`mappingList.${index}.targetFieldKey`" hide-label>
              <!--目标字段  -->
              <jw-select popup-container=".ly-field-mapping" :disabled="targetFieldKeyDisabled" v-model="item.targetFieldKey" placeholder="请选择" :options="targetEntityObj" @change="targetChange($event, index)" :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }" allow-search>
                <template #label="{ data }"> {{ `${data.label}-【${outFieldTypeObj[data.fieldType] || '-'}】` }}</template>
                <template #option="{ data }">
                  <span :title="`${data.label}-【${outFieldTypeObj[data.fieldType] || '-'}】`"> {{ `${data.label}-【${outFieldTypeObj[data.fieldType] || '-'}】` }}</span>
                </template>
              </jw-select>
            </jw-form-item>
          </jw-col>
          <jw-col span="1" class="equal">=</jw-col>
          <template v-if="!(targetFieldKeyDisabled && entity == 16 && filterSelectOptions(item.targetFieldType, item)?.length == 1)">
            <jw-col span="5">
              <!--映射类型下拉选择  -->
              <jw-form-item :field="`mappingList.${index}.mappingType`" hide-label>
                <jw-select popup-container=".ly-field-mapping" v-model="item.mappingType" @change="selectTypeChange($event, index)" placeholder="请选择" :options="filterSelectOptions(item.targetFieldType, item)" :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }" class="mapping-type">
                  <template #option="{ data }">
                    <span :title="data.label">{{ data.label }}</span>
                  </template>
                </jw-select>
              </jw-form-item>
            </jw-col>
          </template>
          <jw-col :span="mappingList?.length > 1 ? 8 : 9">
            <!-- 源字段 -->
            <!-- item.mappingType !== 3  3(空值) -->
            <jw-form-item v-if="item.mappingType !== 3" :field="`mappingList.${index}.mappingValue`" hide-label>
              <template v-if="item.mappingType === 1">
                <jw-dropdown
                  popup-container=".ly-field-mapping"
                  @popup-visible-change="
                    () => {
                      data.searchGroup = '';
                      data.searchField = '';
                    }
                  "
                  placeholder="请选择"
                >
                  <jw-input-tag v-model="item.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!item.isDelete ? item.mappingLabel : ''" :error="item.isDelete" :tagProps="{ color: item.isDelete ? 'red' : '' }" class="mapping-tag"></jw-input-tag>
                  <template #content>
                    <jw-space direction="vertical" fill style="width: 100%">
                      <template v-if="smStepList?.filter((s) => s.triggerType != 5)?.length">
                        <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                        <div>
                          <template v-for="(group, groupIndex) in data.searchGroup ? smStepList?.filter((v) => v.triggerType != 5 && v.label?.includes(data.searchGroup)) : smStepList?.filter((s) => s.triggerType != 5)" :key="groupIndex">
                            <jw-dsubmenu popup-container=".ly-field-mapping" position="left" style="max-width: 220px">
                              <template #default>
                                <span :title="group.label">{{ group.label }}</span>
                              </template>
                              <template #content>
                                <jw-space direction="vertical" fill>
                                  <div v-if="smFieldList(item, group.children)?.length" class="group-show-fields">
                                    <jw-input-search v-model="data.searchField" size="small" :style="{ width: '92.5%', margin: '8px' }" :placeholder="$t('搜索字段名称')" allow-clear />
                                    <div class="group-show-fields-list">
                                      <template v-for="(field, fieldIndex) in data.searchField ? smFieldList(item, group.children)?.filter((v) => v.fieldName?.includes(data.searchField)) : smFieldList(item, group.children)" :key="fieldIndex">
                                        <jw-doption @click="selectField(group, index, field)" :title="`${field.fieldName}-【${outFieldTypeObj[field.fieldType]}】`">{{ field.fieldName }}-【{{ outFieldTypeObj[field.fieldType] }}】</jw-doption>
                                      </template>
                                    </div>
                                  </div>
                                  <div style="padding: 4px 8px" v-else>暂无可选字段</div>
                                </jw-space>
                              </template>
                            </jw-dsubmenu>
                          </template>
                        </div>
                      </template>
                      <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                    </jw-space>
                  </template>
                </jw-dropdown>
              </template>
              <template v-else-if="item.mappingType === 5">
                <jw-dropdown
                  popup-container=".ly-field-mapping"
                  @popup-visible-change="
                    () => {
                      data.searchGroup = '';
                      data.searchField = '';
                    }
                  "
                  placeholder="请选择"
                >
                  <jw-input-tag v-model="item.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!item.isDelete ? item.mappingLabel : ''" :error="item.isDelete" :tagProps="{ color: item.isDelete ? 'red' : '' }" class="mapping-tag"></jw-input-tag>
                  <template #content>
                    <jw-space direction="vertical" fill style="width: 100%">
                      <template v-if="smStepList?.length">
                        <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                        <div>
                          <template v-for="(group, groupIndex) in smStepList?.filter((v) => v.triggerType == 5)" :key="groupIndex">
                            <jw-doption popup-container=".ly-field-mapping" position="left" style="max-width: 220px" @click="selectField(group, index)">
                              <template #default>
                                <span :title="group.label">{{ group.label }}</span>
                              </template>
                            </jw-doption>
                          </template>
                        </div>
                      </template>
                      <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                    </jw-space>
                  </template>
                </jw-dropdown>
              </template>
              <!-- 动态记录特殊处理 -->
              <template v-else-if="item.mappingType === 6 && entity == 16">
                <jw-dropdown
                  popup-container=".ly-field-mapping"
                  @popup-visible-change="
                    () => {
                      data.searchGroup = '';
                      data.searchField = '';
                    }
                  "
                  placeholder="请选择"
                >
                  <jw-input-tag v-model="item.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!item.isDelete ? item.mappingLabel : ''" :error="item.isDelete" :tagProps="{ color: item.isDelete ? 'red' : '' }" class="mapping-tag"></jw-input-tag>
                  <template #content>
                    <jw-space direction="vertical" fill style="width: 100%">
                      <template v-if="smStepList?.filter((v) => v.entity != 16)?.length">
                        <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                        <div>
                          <template v-for="(group, groupIndex) in smStepList?.filter((v) => v.entity != 16)" :key="groupIndex">
                            <jw-doption popup-container=".ly-field-mapping" position="left" style="max-width: 220px" @click="selectField(group, index, null, '对象', true)">
                              <template #default>
                                <span :title="group.label">{{ group.label?.replace('记录', '对象') }}</span>
                              </template>
                            </jw-doption>
                          </template>
                        </div>
                      </template>
                      <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                    </jw-space>
                  </template>
                </jw-dropdown>
              </template>
              <template v-else-if="item.mappingType === 2 && entity == 16">
                <jw-select :max-tag-count="1" v-model="item.mappingValue" :options="data.entity16FieldExt" @change="selectTypeEntity16Change($event, index)" :field-names="{ value: 'value', label: 'label' }" :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请选择')" class="mapping-select">
                  <!-- <template #label="{ data }">
                    <div @click="selectField(group, index,null,null,true)" >{{data.label}}</div>
                  </template> -->
                </jw-select>
              </template>
              <template v-else-if="item.mappingType === 4 && entity == 16">
                <jw-dropdown
                  popup-container=".ly-field-mapping"
                  @popup-visible-change="
                    () => {
                      data.searchGroup = '';
                      data.searchField = '';
                    }
                  "
                  placeholder="请选择"
                >
                  <jw-input-tag v-model="item.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!item.isDelete ? item.mappingLabel : ''" :error="item.isDelete" :tagProps="{ color: item.isDelete ? 'red' : '' }" class="mapping-tag"></jw-input-tag>
                  <template #content>
                    <jw-space direction="vertical" fill style="width: 100%">
                      <template v-if="smStepList?.filter((v) => v.entity != 16)?.length">
                        <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                        <div>
                          <template v-for="(group, groupIndex) in smStepList?.filter((v) => v.entity != 16 && v.entity == mappingList[0]?.mappingValue?.split(':')?.[mappingList[0]?.mappingValue?.split(':')?.length - 1])" :key="groupIndex">
                            <jw-doption popup-container=".ly-field-mapping" position="left" style="max-width: 220px" @click="selectField(group, index)">
                              <template #default>
                                <span :title="group.label">{{ group.label }}</span>
                              </template>
                            </jw-doption>
                          </template>
                        </div>
                      </template>
                      <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                    </jw-space>
                  </template>
                </jw-dropdown>
              </template>
              <template v-else-if="item.mappingType === 4">
                <jw-dropdown
                  popup-container=".ly-field-mapping"
                  @popup-visible-change="
                    () => {
                      data.searchGroup = '';
                      data.searchField = '';
                    }
                  "
                  placeholder="请选择"
                >
                  <jw-input-tag v-model="item.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!item.isDelete ? item.mappingLabel : ''" :error="item.isDelete" :tagProps="{ color: item.isDelete ? 'red' : '' }" class="mapping-tag"></jw-input-tag>
                  <template #content>
                    <jw-space direction="vertical" fill style="width: 100%">
                      <template v-if="smStepList?.length">
                        <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                        <div>
                          <template v-for="(group, groupIndex) in data.searchGroup ? smStepList?.filter((v) => v.label?.includes(data.searchGroup))?.filter((e) => e?.value?.split(':')?.[2] == item?.targetExt) : smStepList?.filter((e) => e?.value?.split(':')?.[2] == item?.targetExt)" :key="groupIndex">
                            <jw-doption popup-container=".ly-field-mapping" position="left" style="max-width: 220px" @click="selectField(group, index)">
                              <template #default>
                                <span :title="group.label">{{ group.label }}</span>
                              </template>
                            </jw-doption>
                          </template>
                        </div>
                      </template>
                      <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                    </jw-space>
                  </template>
                </jw-dropdown>
              </template>

              <template v-else>
                <!-- 单选按钮、多选按钮、单选下拉、多选下拉、级联 -->
                <jw-select v-if="[2, 3, 4, 5, 10].includes(item?.targetFieldType)" :max-tag-count="1" v-model="item.mappingValue" :options="tools.isJSON(item.targetExt) ? JSON.parse(item?.targetExt) : item.targetExt" :field-names="{ value: 'targetValue', label: 'targetLabel' }" :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请选择字段')" allow-search allow-clear :multiple="[3, 5].includes(item?.targetFieldType)" class="mapping-select">
                  <template v-if="item?.targetFieldType !== 10" #label="{ data }">
                    <ly-show-filters :showInner="data.targetLabel" showType="mapping" />
                  </template>
                </jw-select>
                <!-- 人员 -->

                <template v-else-if="item?.targetFieldType === 6">
                  <fh-person position="bl" trigger-type="close" :maxTagCount="1" :item="{ userList: item?.business?.userIds }" :multiple="tools.isJSON(item?.targetExt) ? (JSON.parse(item?.targetExt)?.single == 1 ? false : true) : true" @cb="getDeptUser($event, index, 1)"> </fh-person>
                </template>
                <!-- 数字类型 -->
                <template v-else-if="item?.targetFieldType === 7">
                  <jw-input-number v-if="tools.isJSON(item?.targetExt) && JSON.parse(item?.targetExt)?.numberFormat === '100'" :precision="3" v-model="item.mappingValue" :placeholder="$t('请选择')" allow-clear hide-button>
                    <template #append> % </template>
                  </jw-input-number>
                  <jw-input-number v-else-if="tools.isJSON(item?.targetExt) && JSON.parse(item?.targetExt)?.numberUnit" v-model="item.mappingValue" :placeholder="$t('请选择')" allow-clear @input="(event) => getPrecisionNum(event, item)" :formatter="(event) => isShowThousandFormatter(event, item)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(item, precisionNum)">
                    <template #append> {{ (tools.isJSON(item?.targetExt) && JSON.parse(item?.targetExt)?.numberUnit) || '' }} </template>
                  </jw-input-number>
                  <jw-input-number v-else v-model="item.mappingValue" :placeholder="$t('请选择')" allow-clear @input="(event) => getPrecisionNum(event, item)" :formatter="(event) => isShowThousandFormatter(event, item)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(item, precisionNum)" />
                </template>
                <!-- 日期格式 -->
                <template v-else-if="item?.targetFieldType === 8">
                  <jw-date-picker style="width: 100%" v-model="item.mappingValue" :placeholder="$t('请选择')" :show-time="isShowTime(item)" :value-format="isShowTime(item) ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" :format="item?.targetExt" position="br" />
                </template>
                <!-- 日期范围 -->
                <template v-else-if="item?.targetFieldType === 9">
                  <jw-range-picker v-if="item?.targetExt === '0'" v-model="item.mappingValue" />
                  <jw-range-picker v-else-if="item?.targetExt === '1'" v-model="item.mappingValue" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" />
                  <jw-range-picker v-else v-model="item.mappingValue" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" />
                </template>
                <!-- 级联选择器 -->
                <jw-cascader v-model="item.mappingValue" v-else-if="item?.targetFieldType === 10 && JSON.parse(item?.targetExt)" :trigger-props="{ updateAtScroll: true }" :options="tools.isJSON(item?.targetExt) && JSON.parse(item?.targetExt)" :placeholder="$t('请选择')" path-mode allow-clear allow-search />
                <!-- 金额 -->
                <template v-else-if="item?.targetFieldType === 16">
                  <jw-input-number v-model="item.mappingValue" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, item)" :formatter="(event) => isShowThousandFormatter(event, item)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(item, precisionNum)" />
                </template>
                <!-- 百分比 -->
                <template v-else-if="item?.targetFieldType === 23">
                  <jw-input-number v-model="item.mappingValue" @input="(event) => getPrecisionNum(event, item)" :precision="getPrecision(item, precisionNum)" :placeholder="$t('请输入')" allow-clear hide-button>
                    <template #append> % </template>
                  </jw-input-number>
                </template>
                <!-- 部门 -->
                <xl-tree-member-modal
                  @cb="getDeptUser($event, index, 2)"
                  v-else-if="item?.targetFieldType === 22"
                  style="width: 100%"
                  ref="xlTreeMember"
                  :tree="departTree"
                  :multipleDep="item?.targetExt == 1 ? false : true"
                  :depart="
                    item.business?.deptIds?.map((v) => {
                      return { id: v.id, departmentName: v.departmentName };
                    })
                  "
                >
                  <jw-input-tag :title="item.mappingLabel" class="mapping-tag" v-model="item.mappingLabel" :max-tag-count="1" readonly :placeholder="$t('请选择')" />
                </xl-tree-member-modal>
                <!-- 其他类型 -->
                <jw-input v-else v-model="item.mappingValue" placeholder="请选择" />
              </template>
            </jw-form-item>
          </jw-col>
          <jw-col v-if="mappingList?.length > 1 && entity != 16 && targetFieldKeyDisabled === false" span="1">
            <icon-minus-circle class="minus-icon" @click="minusMappingItem(item, index)" :size="20" />
          </jw-col>
          <!-- 字段类型为2，3，4，5,10 需要显示下拉框 -->
          <div v-if="data.fieldTypeSelectOptions.includes(item.targetFieldType) && item.mappingType === 1 && item.mappingLabel?.length && item.mappingExt?.length" class="rule-item-field-wrap">
            <div class="rule-item-field-inner">
              <jw-list
                :bordered="false"
                :virtualListProps="{
                  height: item.mappingExt.length > 6 ? '200px' : 'auto',
                  buffer: 10,
                  threshold: 50,
                  fixedSize: true
                }"
                :data="item.mappingExt"
              >
                <template #item="{ item: listItem, index: i }">
                  <jw-list-item :key="i">
                    <div :class="['rule-item-field-inner-box', `rule-item-field-inner-box-${index}`]">
                      <jw-row class="rule-item-field-inner-item" :class="`rule-item-field-inner-item-${index}-${i}`">
                        <jw-col span="11">
                          <jw-select v-model="listItem.targetValue" :options="tools.isJSON(item?.targetExt) ? JSON.parse(item?.targetExt) : []" :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请选择字段')" @change="changeTargetSelectField($event, index, i)" allow-search allow-clear :field-names="{ value: 'targetValue', label: 'targetLabel' }"></jw-select>
                        </jw-col>
                        <jw-col span="2" class="equal">=</jw-col>
                        <jw-col span="11">
                          <jw-form-item hide-label hide-asterisk validate-trigger="change" :rules="[{ required: true, message: $t('请选择映射对象和源对象对应的字段值') }]">
                            <jw-select :popup-visible="false" v-model="listItem.sourceLabel" :field-names="{ value: 'sourceValue', label: 'sourceLabel' }" disabled :trigger-props="{ updateAtScroll: true }" :placeholder="$t('请选择字段')" allow-search allow-clear></jw-select>
                          </jw-form-item>
                        </jw-col>
                      </jw-row>
                    </div>
                  </jw-list-item>
                </template>
              </jw-list>
            </div>
          </div>
        </template>
      </jw-row>
    </jw-form>
    <jw-button v-if="entity != 16 && targetFieldKeyDisabled === false" class="add-btn" type="outline" size="mini" @click="addMappingItem" :disabled="fieldDisabled">
      <template #icon>
        <icon-plus />
      </template>
      <template #default>添加</template>
    </jw-button>
  </div>
</template>

<script setup>
import { reactive, ref, computed, inject, watch, nextTick, onMounted } from 'vue';
import { outFieldTypeObj } from '@/utils/const';
import { tools } from '@/utils/tools';
import dayjs from 'dayjs';

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

// import { useI18n } from 'vue-i18n';
// const { t } = useI18n();
console.log('1-开始创建组件-setup');
const props = defineProps({
  targetObj: {
    type: Object,
    default: () => {}
  },
  //步骤索引
  stepIndex: {
    type: Number,
    default: 1
  },
  entity: {
    type: [String, Number],
    default: ''
  },
  mapList: {
    type: Array,
    default: () => []
  },
  targetFieldKeyDisabled: {
    type: [Boolean],
    default: () => false
  },
  recordType: {
    type: [Number] // 操作类型
  }
});
console.log('映射入参', props);
const stepIndex = computed(() => props.stepIndex + 2);
const randomKey = ref(0);
const lyFieldMappingRef = ref();
console.log('条件容器', lyFieldMappingRef);
const emits = defineEmits(['cb']);
const mapLists = computed(() =>
  props.mapList?.map((v) => {
    return {
      ...v,
      mappingValue: [1, 4, 5, 6].includes(v.mappingType) ? v.mappingValue : v.mappingType == 2 ? (v.targetFieldType === 16 ? tools.getPrice(v.mappingValue, v?.targetExt || 2) : v.targetFieldType === 23 ? tools.getPercentage(v.mappingValue, tools.isJSON(v.targetExt) && JSON.parse(v.targetExt)?.numberFormat) : v.mappingValue) : null,
      mappingLabel: v.mappingType == 2 ? (v.targetFieldType === 6 ? v?.business?.userIds?.map((e) => e.name) || [] : v.targetFieldType === 22 ? v?.business?.departIds?.map((e) => e.name) || [] : v.mappingLabel || []) : [1, 4, 5, 6].includes(v.mappingType) ? v.mappingLabel || [] : [],
      business: v.targetFieldType === 6 ? (v.business?.userIds ? v.business : { userIds: [] }) : v.targetFieldType === 22 ? (v.business?.departIds ? v.business : { departIds: [] }) : {}
    };
  })
);
console.log(140, props.mapList, mapLists.value);
const data = reactive({
  selectOptions: [
    {
      label: '字段',
      value: 1
    },
    {
      label: '自定义',
      value: 2
    },
    {
      label: '记录',
      value: 4
    },
    {
      label: '空值',
      value: 3
    },
    {
      label: 'AI生成',
      value: 5
    }
  ],
  searchGroup: '',
  searchField: '',
  fieldTypeSelectOptions: [2, 3, 4, 5, 10],
  targetFilterEntity: [13, 31, 24, 27], //作为目标对象字段需要过滤掉的字段类型
  // sourceFieldEntity: [12, 21, 25, 27], //作为源对象字段需要过滤掉的字段类型
  triggerInfo: inject('flowStepParams')?.triggerInfo,
  sourceMappingFieldList: inject('flowStepParams')?.sourceMappingFieldList,
  fieldTypeMapping: {
    0: [0, 2, 4, 6, 7, 8, 9, 10, 11, 13, 16, 22, 23, 24],
    1: [0, 1, 2, 4, 6, 7, 8, 9, 10, 11, 13, 16, 22, 23, 24],
    2: [2, 4],
    3: [3, 5],
    4: [2, 4],
    5: [3, 5],
    6: [6],
    7: [7, 16, 23, 24],
    8: [8],
    9: [9],
    10: [10],
    11: [0, 11],
    12: [12],
    16: [7, 16, 24],
    18: [18],
    22: [22],
    23: [7, 23, 24],
    25: [25],
    26: [26]
  },
  entityObj: inject('flowStepParams')?.entityObj,
  // 动态记录特殊处理 下拉选项值
  entity16FieldExt: []
});
console.log('映射数据', data);
// 是否展示时间
const isShowTime = (sub) => {
  const ext = tools.isJSON(sub?.targetExt) ? JSON.parse(sub?.targetExt) : sub?.targetExt;
  if (!ext) return false;
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};

// 根据字段类型筛选映射条件
const filterSelectOptions = (targetFieldType, item) => {
  if (props.entity == 16 && props.targetFieldKeyDisabled == true && item?.targetFieldKey == 'businessId') {
    return [
      {
        label: '记录',
        value: 4
      }
    ];
  }
  if (props.entity == 16 && props.targetFieldKeyDisabled == true) {
    return [
      // {
      //   label: '对象',
      //   value: 6
      // },
      {
        label: '自定义',
        value: 2
      }
    ];
  }
  if (targetFieldType == 18) {
    return data.selectOptions.filter((v) => v.value !== 2 && v.value !== 4 && v.value !== 5);
  } else if (targetFieldType == 26) {
    return data.selectOptions.filter((v) => v.value !== 2 && v.value !== 4);
  } else if ([12, 25].includes(targetFieldType)) {
    return data.selectOptions.filter((v) => v.value !== 2 && v.value !== 5);
  } else if ([0, 1].includes(targetFieldType)) {
    return data.selectOptions.filter((v) => v.value !== 4);
  }
  return data.selectOptions.filter((v) => v.value !== 4 && v.value !== 5);
};
// 步骤集合
const smStepList = computed(() => {
  const list = data.sourceMappingFieldList?.filter((val) => val.step < stepIndex.value) || [];
  console.log('smStepList-字段', list);
  return list;
});
// 根据映射关系筛选可选字段
const smFieldList = (item, list) => {
  const fieldType = item.targetFieldType;

  if ([12, 25].includes(fieldType)) {
    return list?.filter((val) => data.fieldTypeMapping[fieldType]?.includes(val.fieldType) && val.fieldExt == item.targetExt);
  } else {
    return list?.filter((val) => data.fieldTypeMapping[fieldType]?.includes(val.fieldType));
  }
};
const mappingList = ref(mapLists.value || []);
console.log('mappingList', mappingList);

// 目标对象的字段集合(过滤掉系统字段、引用字段、当前节点)
const specialPersonField = ['followUser', 'csmChargePerson', 'chargePerson']; /// 线索：followUser 售后服务：csmChargePerson 其他：chargePerson
const targetEntityObj = ref(
  props.targetObj
    ?.filter((v) => v.type !== 0 && v.fieldType != 21 && v.value !== 'currentStage' && !data.targetFilterEntity?.includes(v.fieldType) && (props.recordType === 4 ? !specialPersonField.includes(v.value) : true))
    .map((v) => {
      const targetFieldKey = mappingList.value?.map((v) => v.targetFieldKey);
      return {
        ...v,
        disabled: targetFieldKey.includes(v.value) ? true : false
      };
    })
    ?.sort((a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1))
);
// 字段映射处 过滤  动态记录的两个特殊字段
if (props.targetFieldKeyDisabled === false) {
  targetEntityObj.value = targetEntityObj.value?.filter((v) => v.value != 'entityType' && v.value != 'businessId');
}
const fieldDisabled = ref(mappingList.value?.length === targetEntityObj.value?.length ? true : false);
// 计算字段禁用状态的辅助函数
const updateFieldState = () => {
  const keyList = mappingList.value?.map((v) => v.targetFieldKey);
  targetEntityObj.value = targetEntityObj.value?.map((v) => ({
    ...v,
    disabled: keyList?.includes(v.value)
  }));

  // 重新排序，禁用后将已禁用的字段放在最后边
  targetEntityObj.value?.sort((a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1));
  // 更新添加按钮状态
  fieldDisabled.value = targetEntityObj.value?.every((v) => v.disabled);
};

const flattenCascadeData = (data) => {
  const flattenedData = [];
  function processItem(item, pathLabels = [], pathValues = []) {
    const newPathLabels = [...pathLabels, item.label];
    const newPathValues = [...pathValues, item.value];
    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => processItem(child, newPathLabels, newPathValues));
    } else {
      const label = newPathLabels.join('/');
      const value = newPathValues.join('/');
      const flattenedItem = { label, value };
      flattenedData.push(flattenedItem);
    }
  }
  data.forEach((rootItem) => processItem(rootItem));
  return flattenedData;
};

const targetChange = (v, index) => {
  const ft = targetEntityObj.value?.find((m) => m.value === v);
  const mExt =
    [2, 3, 4, 5].includes(ft.fieldType) && tools.isJSON(ft.fieldExt)
      ? JSON.parse(ft.fieldExt)?.map((v) => {
          return {
            targetLabel: v.label,
            targetValue: v.value
          };
        })
      : ft.fieldExt;
  // 级联选择器的下拉数据
  const cascaderList =
    ft.fieldType === 10 && tools.isJSON(ft.fieldExt)
      ? flattenCascadeData(JSON.parse(ft.fieldExt))?.map((v) => {
          return {
            targetLabel: v.label,
            targetValue: v.value
          };
        })
      : ft.fieldExt;
  mappingList.value[index] = {
    targetFieldKey: v,
    targetFieldType: ft?.fieldType,
    mappingType: 1,
    mappingValue: null,
    mappingLabel: [],
    business: ft?.fieldType === 6 ? { userIds: [] } : ft?.fieldType === 22 ? { deptIds: [] } : {},
    targetExt: ft?.fieldType === 10 ? JSON.stringify(cascaderList) : [2, 3, 4, 5].includes(ft.fieldType) && mExt ? JSON.stringify(mExt) : mExt,
    mappingExt: []
  };
  updateFieldState();
};

const selectTypeEntity16Change = (v, index) => {
  mappingList.value[index].mappingValue = v;
  mappingList.value?.forEach((v) => {
    if (v.targetFieldKey == 'businessId') {
      v.mappingLabel = [];
      v.mappingValue = '';
      v.allCycleList = [];
    }
  });
};

// 类型为【字段】时，源字段的dropdown选择事件
const selectField = (group, index, v, objectTitle = null, isEntityType = null) => {
  if (objectTitle) {
    group.label = group.label.replace('记录', '对象');
  }
  //此处mappingLabel设为数组是因为使用了input-tag接收的数组，为了方便前端展示，跟后端约定使用list-string格式:['第1步: | 字段名字-【字段类型】']
  mappingList.value[index].mappingLabel = v ? [`第${group.step}步 | ${v.fieldName}-【${outFieldTypeObj[v.fieldType]}】`] : [group.label];

  if (group?.triggerType == 5) {
    mappingList.value[index].mappingValue = group.value;
  } else {
    mappingList.value[index].mappingValue = v ? `${group.value}:${v.fieldKey}` : group.value;
  }
  if (group.step >= 1) {
    const list = group.step == 1 ? [] : data.triggerInfo[group.step - 2].allCycleList;
    mappingList.value[index].allCycleList = [...new Set([...list, group.step + 1000])];
  } else {
    mappingList.value[index].allCycleList = [];
  }
  mappingList.value[index].isDelete = false;
  // 添加来源字段的下拉选项值
  // console.log('来源字段下拉选项值', mappingList.value[index]?.targetFieldType);
  if ([2, 3, 4, 5, 10].includes(mappingList.value[index]?.targetFieldType)) {
    const sfl = tools.isJSON(v.fieldExt) && mappingList.value[index]?.targetFieldType === 10 ? flattenCascadeData(JSON.parse(v.fieldExt)) : JSON.parse(v.fieldExt); //来源字段的下拉选项

    const mtx = tools.isJSON(mappingList.value[index]?.targetExt) ? JSON.parse(mappingList.value[index]?.targetExt) : mappingList.value[index]?.targetExt; // 目标字段的下拉选项

    const mtxMap = mtx.reduce((acc, item) => {
      acc[item.targetLabel] = item.targetValue;
      return acc;
    }, {});

    mappingList.value[index].mappingExt = sfl?.map((v) => {
      const targetValue = mtxMap[v.label] || ''; // 使用对象查找，避免遍历
      return {
        targetLabel: v.label,
        targetValue,
        sourceLabel: v.label || '',
        sourceValue: v.value || ''
      };
    });
  } else {
    mappingList.value[index].mappingExt = [];
  }
  // 如果isEntityType为true，则将mappingLabel设置为group.label   来源数据对象切换时
  if (isEntityType) {
    mappingList.value?.forEach((v) => {
      if (v.targetFieldKey == 'businessId') {
        v.mappingLabel = [];
        v.mappingValue = '';
        v.allCycleList = [];
      }
    });
  }
};
// 修改目标字段
const changeTargetSelectField = (v, index, i) => {
  //主要修改的是targetValue,后端希望把targetLabel也同步更新一下，所以此根据targetExt同步更新mappingExt的targetLabel
  const targetExt = tools.isJSON(mappingList.value[index]?.targetExt) ? JSON.parse(mappingList.value[index]?.targetExt) || [] : mappingList.value[index]?.targetExt || [];
  mappingList.value[index].mappingExt[i].targetValue = v;
  mappingList.value[index].mappingExt[i].targetLabel = targetExt?.find((e) => e.targetValue === v)?.targetLabel;
};
// console.log(changeTargetSelectField);
// 添加映射项
const addMappingItem = () => {
  mappingList.value.push({
    targetFieldKey: '',
    mappingType: 1,
    mappingValue: null,
    mappingLabel: [],
    targetFieldType: null,
    targetExt: JSON.stringify([]),
    mappingExt: []
  });

  // 当添加的字段等于可选目标字段时禁用按钮
  fieldDisabled.value = mappingList.value?.length === targetEntityObj.value?.length ? true : false;

  // 滚动到底部
  // 等待 DOM 更新完成后滚动到底部
  nextTick(() => {
    if (lyFieldMappingRef.value) {
      lyFieldMappingRef.value.scrollTo({
        top: lyFieldMappingRef.value.scrollHeight,
        behavior: 'smooth'
      });
    }
  });
};
// 左侧列表选择激活态结束
// const personTree = ref({
//   checkDepartment: false
// });
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
//映射类型下拉选择改变时
const selectTypeChange = (v, index) => {
  mappingList.value[index].mappingType = v;
  mappingList.value[index].mappingValue = '';
  mappingList.value[index].mappingLabel = [];
  // mappingList.value[index].business.userIds = [];
  // mappingList.value[index].business.deptIds = [];
  // mappingList.value[index].departList = [];
  // mappingList.value[index].userNames = [];
  // mappingList.value[index].userList = [];
  const mtp = tools.isJSON(mappingList.value[index].targetExt) ? JSON.parse(mappingList.value[index].targetExt) : mappingList.value[index].targetExt;
  if (v === 2) {
    if ([2, 3, 4, 5, 10].includes(mappingList.value[index]?.targetFieldType)) {
      const te = mtp?.map((v) => {
        return {
          targetLabel: v.targetLabel,
          targetValue: v.targetValue
        };
      });
      mappingList.value[index].targetExt = JSON.stringify(te);
    }
  } else {
    mappingList.value[index].mappingExt = [];
    mappingList.value[index].mappingLabel = [];
  }
};
// 删除映射项
const minusMappingItem = (item, index) => {
  console.log(311, item, index);
  mappingList.value?.splice(index, 1);
  updateFieldState();
  randomKey.value++;
};
// 添加人员角色--获取部门或者用户的值
const getDeptUser = (v, index, type) => {
  // prop为field值，单一清除时使用
  console.log('人员选择查看:', v, index, type, mappingList.value[index]);
  if (type === 1) {
    // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
    const userNames = v?.userList?.map((u) => u.userName);
    const userIds = v?.userList?.map((u) => u.id);
    console.log(450, userNames, userIds);
    mappingList.value[index].business.userIds = v?.userList;
    mappingList.value[index].mappingLabel = userNames;
    mappingList.value[index].mappingValue = userIds?.join();
  } else {
    const deptNames = v?.departList?.map((u) => u.departmentName);
    const deptIds = v?.departList?.map((u) => u.id);
    mappingList.value[index].business.deptIds = v?.departList;
    mappingList.value[index].mappingLabel = deptNames;
    mappingList.value[index].mappingValue = deptIds?.join();
  }
  randomKey.value++;
};

onMounted(() => {
  if (props.entity == 16 && data.entityObj[props.entity]?.find((v) => v.fieldKey == 'entityType')?.fieldExt) {
    data.entity16FieldExt = JSON.parse(data.entityObj[props.entity]?.find((v) => v.fieldKey == 'entityType')?.fieldExt);
  }
});

watch(
  () => mappingList.value,
  (v) => {
    const params = v?.map((v) => {
      return {
        ...v,
        mappingValue: [1, 4, 5, 6].includes(v.mappingType) ? v.mappingValue : v.mappingType == 2 ? ([3, 5].includes(v.targetFieldType) && v.mappingValue?.length ? v.mappingValue?.filter((v) => v && v !== '') : v.targetFieldType === 16 ? tools.setPrice(v.mappingValue, v?.targetExt || 2) : v.targetFieldType === 23 ? tools.setPercentage(v.mappingValue, tools.isJSON(v.targetExt) && JSON.parse(v.targetExt)?.numberFormat) : v.mappingValue) : null
      };
    });
    emits('cb', params, props.targetFieldKeyDisabled);
  },
  { deep: true, immediate: true }
);
</script>
<style scoped lang="less">
@import './ly-field-mapping.less';
</style>
